export default {
    "agriculture": /* @icon */"seedling",
    "arts": /* @icon */"palette",
    "automotive": /* @icon */"car",
    "aviation": /* @icon */"plane",
    "banking": /* @icon */"university",
    "business": /* @icon */"briefcase",
    "construction": /* @icon */"hard-hat",
    "education": /* @icon */"graduation-cap",
    "energy": /* @icon */"bolt",
    "engineering": /* @icon */"cogs",
    "entertainment": /* @icon */"film",
    "environment": /* @icon */"leaf",
    "fashion": /* @icon */"tshirt",
    "finance": /* @icon */"dollar-sign",
    "food-and-beverage": /* @icon */"utensils",
    "general": /* @icon */"globe",
    "geography": /* @icon */"map-marked-alt",
    "health-and-fitness": /* @icon */"dumbbell",
    "healthcare": /* @icon */"stethoscope",
    "hospitality": /* @icon */"concierge-bell",
    "humanities": /* @icon */"book",
    "insurance": /* @icon */"shield-alt",
    "law": /* @icon */"gavel",
    "manufacturing": /* @icon */"industry",
    "mathematics": /* @icon */"square-root-alt",
    "media": /* @icon */"newspaper",
    "medicine": /* @icon */"pills",
    "military": /* @icon */"medal",
    "mining": /* @icon */"hard-hat",
    "pharmaceuticals": /* @icon */"capsules",
    "politics": /* @icon */"balance-scale",
    "real-estate": /* @icon */"home",
    "religion": /* @icon */"praying-hands",
    "retail": /* @icon */"shopping-cart",
    "science": /* @icon */"flask",
    "sports": /* @icon */"futbol",
    "technology": /* @icon */"microchip",
    "telecommunications": /* @icon */"satellite-dish",
    "transportation": /* @icon */"shipping-fast",
    "travel": /* @icon */"passport",
    "utilities": /* @icon */"tools"
  }
  